import { KITCHEN_ITEM_STATUS } from "../all-types";

type StatusOrTypeInfo = {
  kind: "status" | "type";
  key: string;
  displayText: string;
  color: "default" | "primary" | "secondary" | "error" | "warning" | "info" | "success";
  bgColor: string;
  textColor: string;
  borderColor?: string;
};

export const getKitchenItemStatusInfo = (
  input: KITCHEN_ITEM_STATUS | string
): StatusOrTypeInfo => {
  // Check if input is a known KITCHEN_ITEM_STATUS
  switch (input) {
    case KITCHEN_ITEM_STATUS.IN_CART:
      return {
        kind: "status",
        key: "IN_CART",
        displayText: "In Cart",
        color: "default",
        bgColor: "#6B7280",
        textColor: "#FFFFFF",
      };
    case KITCHEN_ITEM_STATUS.IN_KITCHEN:
      return {
        kind: "status",
        key: "IN_KITCHEN",
        displayText: "In Kitchen",
        color: "primary",
        bgColor: "#3B82F6",
        textColor: "#FFFFFF",
      };
    case KITCHEN_ITEM_STATUS.COOKING:
      return {
        kind: "status",
        key: "COOKING",
        displayText: "Cooking",
        color: "warning",
        bgColor: "#F59E0B",
        textColor: "#000000",
      };
    case KITCHEN_ITEM_STATUS.READY:
      return {
        kind: "status",
        key: "READY",
        displayText: "Ready",
        color: "success",
        bgColor: "#10B981",
        textColor: "#FFFFFF",
      };
    case KITCHEN_ITEM_STATUS.SERVED:
      return {
        kind: "status",
        key: "SERVED",
        displayText: "Served",
        color: "secondary",
        bgColor: "#8B5CF6",
        textColor: "#FFFFFF",
      };
    case KITCHEN_ITEM_STATUS.CANCELLED:
      return {
        kind: "status",
        key: "CANCELLED",
        displayText: "Cancelled",
        color: "error",
        bgColor: "#EF4444",
        textColor: "#FFFFFF",
      };
  }

  // Treat as string order type
  const normalized = String(input).toLowerCase();

  switch (normalized) {
    case "dine-in":
      return {
        kind: "type",
        key: "dine-in",
        displayText: "Dine In",
        bgColor: "#ADEED8",
        textColor: "color8.main",
        borderColor: "color8.main",
        color: "default",
      };
    case "to-go":
      return {
        kind: "type",
        key: "to-go",
        displayText: "To Go",
        bgColor: "#FFF4F3",
        textColor: "color10.main",
        borderColor: "color1.main",
        color: "default",
      };
    case "delivery":
      return {
        kind: "type",
        key: "delivery",
        displayText: "Delivery",
        bgColor: "#FFF9ED",
        textColor: "color10.main",
        borderColor: "color10.main",
        color: "default",
      };
    case "pending":
    case "occupied":
      return {
        kind: "type",
        key: "occupied",
        displayText: "Occupied",
        bgColor: "#FFD700", // Example gold
        textColor: "#000000",
        borderColor: "#B8860B",
        color: "default",
      };
    default:
      return {
        kind: "type",
        key: String(input),
        displayText: "Unknown",
        bgColor: "#FFFFFF",
        textColor: "#000000",
        borderColor: "#000000",
        color: "default",
      };
  }
};
